/**
 * FH-A11Y batch 9 (2026-09-26): screen reader findings SR10, SR11, SR14, SR15, SR16.
 * SR10 unavailable size/color announced; SR11 Related Products controls named; SR14 Share keeps its
 * expanded state and no longer pulls focus back; SR15 desktop menu triggers are buttons with an
 * expanded state; SR16 mobile menu no longer says "expanded" after it closes.
 * Uses window.fhA11yAnnounce from ada-a11y-batch8.js when present.
 * Rollback: remove the ada-a11y-batch9.js line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch9) return;
  window.__fhA11yBatch9 = true;

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function removeAttr(el, name) {
    if (el.hasAttribute(name)) el.removeAttribute(name);
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function say(msg, delay) { if (typeof window.fhA11yAnnounce === 'function') window.fhA11yAnnounce(msg, delay); }

  /* Recent focus history, used to undo focus being pulled back to Share. */
  var focusHist = [];
  document.addEventListener('focusin', function (e) {
    focusHist.push({ el: e.target, t: Date.now() });
    if (focusHist.length > 5) focusHist.shift();
  }, true);

  /* SR14 + SR16: keep a summary's "expanded" state in step with its <details> (Share, the mobile menu,
     and other disclosures). The toggle event doesn't bubble, so listen in the capture phase. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS') return;
    var s = d.querySelector(':scope > summary');
    if (s && s.hasAttribute('aria-expanded')) setAttr(s, 'aria-expanded', d.open ? 'true' : 'false');
  }, true);

  /* SR16: Escape on the mobile menu. The drawer closes after a short animation, but the Menu button kept
     saying "expanded". Mark it collapsed straight away, and make sure the drawer really closes. */
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('details.menu-drawer-container');
    if (!d) return;
    setTimeout(function () {
      if (d.classList.contains('menu-opening')) return; // still open (Escape closed a submenu only)
      var s = d.querySelector(':scope > summary');
      if (s) setAttr(s, 'aria-expanded', 'false');
      setTimeout(function () {
        if (d.hasAttribute('open') && !d.classList.contains('menu-opening')) d.removeAttribute('open');
      }, 800);
    }, 50);
  });

  /* SR14: Share. Tabbing out of the open Share panel closes it, and the theme then moved focus back to
     the Share button. Put focus back where the user was going. */
  function bindShare() {
    document.querySelectorAll('share-button details').forEach(function (d) {
      if (d.__fhShare) return;
      d.__fhShare = true;
      d.addEventListener('toggle', function () {
        if (d.open) return;
        var s = d.querySelector('summary');
        if (s) setAttr(s, 'aria-expanded', 'false');
        if (document.activeElement !== s) return;
        var prev = focusHist[focusHist.length - 2];
        if (prev && prev.el && prev.el !== document.body && prev.el !== s && !d.contains(prev.el) &&
            document.contains(prev.el) && Date.now() - prev.t < 1500) {
          try { prev.el.focus({ preventScroll: true }); } catch (err) { prev.el.focus(); }
        }
      });
    });
  }

  /* SR15: desktop menu (TMenu). Items that open a submenu are javascript: links, so screen readers didn't
     announce their expanded state. Make them buttons (Enter and Space) and keep "expanded" in step. */
  var tmenuMO = null;
  function syncTmenuItem(li) {
    var a = li.querySelector(':scope > a.tmenu_item_link[aria-haspopup]');
    if (!a) return;
    setAttr(a, 'aria-expanded', li.classList.contains('tmenu_item_active') ? 'true' : 'false');
  }
  function fixTmenu() {
    var nav = document.querySelector('.tmenu_navbar');
    if (!nav) return;
    nav.querySelectorAll('.tmenu_item--root > a.tmenu_item_link[aria-haspopup]').forEach(function (a) {
      if (/^javascript:/i.test(a.getAttribute('href') || '')) {
        setAttr(a, 'role', 'button');
        if (!a.__fhKey) {
          a.__fhKey = true;
          a.addEventListener('keydown', function (e) {
            if (e.key !== ' ' && e.key !== 'Spacebar') return;
            e.preventDefault();
            a.click();
          });
        }
      }
      syncTmenuItem(a.parentElement);
    });
    if (!nav.__fhObs) {
      nav.__fhObs = true;
      tmenuMO = new MutationObserver(function (list) {
        list.forEach(function (m) {
          if (m.target.classList && m.target.classList.contains('tmenu_item--root')) syncTmenuItem(m.target);
        });
      });
      tmenuMO.observe(nav, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
  }

  /* SR10: an unavailable size/color combination silently turned the button into "Not Available", still
     announced as opening a dialog. Mark it unavailable and say so. (The theme already announces the new
     price and color itself.) */
  var lastNA = null;
  function submitButton() {
    return document.querySelector('product-form button.product-form__submit') || document.querySelector('button.product-form__submit');
  }
  function fixSubmitState(announce) {
    var b = submitButton();
    if (!b) return;
    var t = txt(b);
    var notFound = b.classList.contains('variantnotfound') || /not available|unavailable/i.test(t);
    var soldOut = !notFound && /sold out/i.test(t);
    var na = notFound || soldOut;
    if (na) {
      setAttr(b, 'aria-disabled', 'true');
      setAttr(b, 'data-fh-na', '1');
      removeAttr(b, 'aria-haspopup');
    } else if (b.getAttribute('data-fh-na') === '1') {
      removeAttr(b, 'data-fh-na');
      removeAttr(b, 'aria-disabled');
      if (document.querySelector('cart-drawer')) setAttr(b, 'aria-haspopup', 'dialog');
    }
    if (!announce) return;
    if (na && lastNA !== t) {
      say(notFound
        ? 'This size and color combination isn’t available. Please choose another size or color.'
        : 'This size and color is sold out.', 900);
    }
    lastNA = na ? t : null;
  }
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('variant-selects, variant-radios')) return;
    lastNA = null;
    setTimeout(function () { fixSubmitState(true); }, 700);
  }, true);

  /* SR11: Related Products (Globo). Every card said "Variant combo box" and "ADD TO CART" with no product
     name, and prices were bare numbers. */
  function addLabel(before, text) {
    var p = before.previousElementSibling;
    if (p && p.classList.contains('fh-a11y-price-label')) { if (p.textContent !== text) p.textContent = text; return; }
    var l = document.createElement('span');
    l.className = 'visually-hidden fh-a11y-price-label';
    l.textContent = text;
    before.parentNode.insertBefore(l, before);
  }
  function fixRelated() {
    document.querySelectorAll('.ga-product').forEach(function (card) {
      var t = txt(card.querySelector('.ga-product_title'));
      if (!t) return;
      var sel = card.querySelector('select.ga-product_variant_select');
      if (sel) setAttr(sel, 'aria-label', 'Size for ' + t);
      var btn = card.querySelector('button.ga-product_addtocart');
      if (btn) {
        var bt = txt(btn);
        setAttr(btn, 'aria-label', /^add to cart$/i.test(bt) ? 'Add ' + t + ' to cart' : bt + ': ' + t);
      }
      var price = card.querySelector('.ga-product_price');
      var old = card.querySelector('.ga-product_oldprice');
      if (price && old && txt(old)) {
        addLabel(price, 'Sale price ');
        addLabel(old, ', regular price ');
      }
    });
  }

  function runAll() {
    try { bindShare(); } catch (e) {}
    try { fixTmenu(); } catch (e) {}
    try { fixSubmitState(false); } catch (e) {}
    try { fixRelated(); } catch (e) {}
  }

  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; runAll(); }, 60);
  }

  function start() {
    runAll();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
